// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cQYm","index":"styles_index__1CUuu"};